module.exports = __webpack_public_path__ + "img/40_38_049_520.1eee3ac8.jpg";